(() => {
  if (!customElements.get('nestling-mega-nav')) customElements.define('nestling-mega-nav', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.groups = [...this.querySelectorAll('.ns-nav__details')];
      const hover = matchMedia('(hover: hover) and (pointer: fine)');
      const pinned = new WeakSet();
      const clear = () => clearTimeout(this.timer);
      const close = except => this.groups.forEach(group => { if (group !== except) { group.open = false; pinned.delete(group); } });
      this.groups.forEach(group => {
        const summary = group.querySelector('summary');
        group.addEventListener('toggle', () => {
          summary.setAttribute('aria-expanded', String(group.open));
          if (group.open) close(group);
          else pinned.delete(group);
        }, options);
        summary.setAttribute('aria-expanded', String(group.open));
        summary.addEventListener('click', event => {
          event.preventDefault(); clear();
          // A mouse click keeps a hover-opened panel available for selection.
          const open = event.detail === 0 ? !group.open : !group.open || !pinned.has(group);
          close(group); group.open = open;
          if (open) pinned.add(group); else pinned.delete(group);
        }, options);
        group.addEventListener('pointerenter', () => {
          clear();
          if (hover.matches) this.timer = setTimeout(() => { close(group); group.open = true; }, 110);
        }, options);
        group.addEventListener('pointerleave', () => {
          clear();
          if (hover.matches && !group.contains(document.activeElement)) this.timer = setTimeout(() => { group.open = false; }, 180);
        }, options);
        summary.addEventListener('keydown', event => {
          if (event.key === 'ArrowDown') {
            event.preventDefault(); clear(); close(group); group.open = true;
            group.querySelector('.ns-nav__panel a')?.focus();
          }
        }, options);
      });
      this.addEventListener('keydown', event => {
        this.closest('nav').setAttribute('data-keyboard', '');
        if (event.key === 'Escape') {
          const group = event.target.closest('details');
          clear(); close(); group?.querySelector('summary').focus();
          event.preventDefault();
        }
      }, options);
      this.addEventListener('pointerdown', () => { clear(); this.closest('nav').removeAttribute('data-keyboard'); }, options);
      this.addEventListener('focusout', event => {
        // activeElement can briefly be body during a pointer focus transfer.
        // Keep the panel open when focus is moving to one of its links.
        if (!this.contains(event.relatedTarget)) { clear(); close(); }
      }, options);
      document.addEventListener('pointerdown', event => { if (!this.contains(event.target)) { clear(); close(); } }, options);
      window.addEventListener('resize', () => { clear(); close(); }, options);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); }
  });
  if (!customElements.get('nestling-mobile-nav')) customElements.define('nestling-mobile-nav', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort(); this.abort = new AbortController();
      const buttons = [...this.querySelectorAll('.ns-mobile-nav__toggle')];
      const set = (button, open) => {
        button.setAttribute('aria-expanded', String(open));
        this.querySelector('#' + button.getAttribute('aria-controls')).hidden = !open;
      };
      buttons.forEach(button => {
        set(button, false);
        button.addEventListener('click', event => {
          // The legacy drawer binds every button as a close action.
          // Handle category toggles during capture so the drawer stays open.
          event.preventDefault(); event.stopImmediatePropagation();
          const open = button.getAttribute('aria-expanded') !== 'true';
          buttons.forEach(other => set(other, other === button && open));
        }, { signal: this.abort.signal, capture: true });
      });
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
})();
